import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from '../app-routing/app-routing.module';
import { TenantService } from '../features/settings/services/tenant-service/tenant.service';
import { UsersService } from '../features/settings/services/users-service/users.service';
import { BankAccountEffects } from './store/bank-account/bank-account.effects';
import { ComplianceFormEffects } from './store/compliance-form/compliance-form.effects';
import {
  CoreFeatureStateKey,
  CoreReducerMap,
} from './store/core-feature-reducer';
import { EnrollmentSelfServiceRegistrationEffects } from './store/enrollment-self-service-registration/enrollment-self-service-registration.effects';
import { EnrollmentsEffects } from './store/enrollments/enrollments.effects';
import { ExchangeStatusEffects } from './store/exchange-status/exchange-status.effects';
import { HeaderAlertsEffects } from './store/header-alerts/header-alerts.effects';
import { ProductRankingEffects } from './store/product-ranking/product-ranking.effects';
import { UserGroupsEffects } from './store/user-groups/user-groups.effects';
import { UserManagementStateEffects } from './store/user-settings/users.effects';
import { ApplicationCountEffects } from './store/application-count/application-count.effects';

@NgModule({
  exports: [RouterModule],
  imports: [
    CommonModule,
    AppRoutingModule,
    MatSnackBarModule,
    StoreModule.forFeature(CoreFeatureStateKey, CoreReducerMap),
    EffectsModule.forFeature([
      ApplicationCountEffects,
      BankAccountEffects,
      HeaderAlertsEffects,
      EnrollmentsEffects,
      ComplianceFormEffects,
      EnrollmentSelfServiceRegistrationEffects,
      ExchangeStatusEffects,
      ProductRankingEffects,
      UserGroupsEffects,
      UserManagementStateEffects,
    ]),
  ],
  providers: [
    TenantService,
    UsersService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {}
